import { HttpMethod } from "@/types/https";
import { WorkspaceResponse, WorkspacesResponse } from "../types/workspace.type";
import { ENDPOINT } from "../endpoint";
import { apiCall } from "../base";

export const WorkspaceList = (params: any) => {
  const stringParams = JSON.stringify(params);
  return {
    name: `WorkspaceList_${stringParams}`,
    handle: (): Promise<WorkspacesResponse> =>
      apiCall<WorkspacesResponse>({
        params,
        url: ENDPOINT.WORKSPACES,
        method: HttpMethod.GET,
      }),
  };
};

export const WorkspaceDetail = (id: number) => {
  return {
    name: `WorkspaceDetail`,
    handle: (): Promise<WorkspaceResponse> =>
      apiCall<WorkspaceResponse>({
        url: `${ENDPOINT.WORKSPACE}/${id}`,
        method: HttpMethod.GET,
      }),
  };
};
